<div
  class="program-box"
  [class.expanded]="expanded"
  [class.in-progress]="changeInProgress"
  (click)="toggleExpand($event)"
>
  <div class="program-type">{{ currentProgramType }}</div>
  <div class="program-name-container">
    <div class="program-name">{{ currentProgramName }}</div>
    <a360-icon class="expand-arrow" icon="arrow-to-right" [color]="iconColors.LIGHT_GREY"></a360-icon>
  </div>
</div>

<div class="programs-list-wraper">
  <div class="programs-list-box" [class.expanded]="expanded" (outsideClick)="onOutsideClick()">
    @for (program of programs; track program) {
    <div class="program-list-item" (click)="changeProgram($event, program)">
      <div class="program-type">{{ program.label }}</div>
      <div class="program-name">{{ program.name }}</div>
    </div>
    }
  </div>
</div>
